export const education = {
  degree: "B.Tech in Computer Science Engineering",
  start: "Nov 2020",
  end: "June 2024",
  cgpa: "9.5",
};
